export default {
  state: {
    languageList: [
      { id: 'da-DK', name: 'Danish', markets: ['dk'] },
      { id: 'de-AT', name: 'German (Austrian)', markets: ['at'] },
      { id: 'de-CH', name: 'German (Switzerland)', markets: ['ch'] },
      { id: 'de-DE', name: 'German (Germany)', markets: ['de'] },
      { id: 'en-GB', name: 'English (UK)', markets: ['gb', 'play', 'au', 'nz'] },
      { id: 'en-US', name: 'English (US)', markets: ['us', 'ca'] },
      { id: 'es-ES', name: 'Spanish', markets: ['es', 'mx'] },
      { id: 'et-EE', name: 'Estonian', markets: ['ee'] },
      { id: 'fi-FI', name: 'Finnish', markets: ['fi'] },
      { id: 'fr-FR', name: 'French', markets: ['fr'] },
      { id: 'it-IT', name: 'Italian', markets: ['it'] },
      { id: 'lt-LT', name: 'Lithuanian', markets: ['lt'] },
      { id: 'lv-LV', name: 'Latvian', markets: ['lv'] },
      { id: 'nb-NO', name: 'Norweigan (Bokmål)', markets: ['no'] },
      { id: 'nl-NL', name: 'Dutch', markets: ['nl'] },
      { id: 'pt-BR', name: 'Portuguese', markets: ['br'] },
      { id: 'ro-RO', name: 'Romanian', markets: ['ro'] },
      { id: 'sv-SE', name: 'Swedish', markets: ['se'] },
    ],
  },
  getters: {
    languageList(state) {
      return state.languageList
    },
    marketsByLanguageID: state => id => {
      return state.languageList.find(language => language.id === id)?.markets
    },
    languageByMarketID: state => id => {
      return state.languageList.find(language => language.markets.includes(id)).name
    },
    languageIDByMarketID: state => id => {
      return state.languageList.find(language => language.markets.includes(id)).id
    },
    languageNameByLanguageID: state => id => {
      return state.languageList.find(language => language.id === id)?.name
    },
  },
}
